interface TagComponentProps {
    text: string;
    textColor?: string;
    backgroundColor?: string;
    fontSize?: string;
    padding?: string;
    className?: string;
}

const TagComponent: React.FC<TagComponentProps> = ({
    text,
    textColor = '#000000',
    backgroundColor = 'rgb(232, 148, 148)',
    fontSize = '0.8rem',
    padding = '0.3rem 0.8rem',
    className = ''
}) => {
    return (
        <div
            className={`tag-component ${className}`}
            style={{
                padding,
                borderRadius: '20px',
                fontSize,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                backgroundColor,
                color: textColor,
                width: 'fit-content'
            }}
        >
            {text}
        </div>
    );
}

export default TagComponent;